<template>
  <div style='touch-action: manipulation'>
    <v-toolbar class="main">
      <button class="nav-back" @click="goBack">&lt; Leveranser</button>
    </v-toolbar>
    <div>
      <h1>Se över leverans</h1>
    </div>

    <v-container grid-list-md text-xs-center inventory>
      <v-layout row wrap mb-3>
          <v-flex xs6>
          <v-card>
              <div class="image-container">
                  <img class="rounded" alt="Helpall" src="../assets/pallet.jpg">
                  <div class="description">Helpall</div>
              </div>

            <div class="counter">
              <v-layout row wrap>
                <v-flex xs4>
                  <v-btn  @click="$store.commit('decrementPalletAmountReturned')"> - </v-btn>
                </v-flex>
                <v-flex xs4>
                  <input class="palletDisplay" v-model="pallet_quantity_returned" readonly>
                </v-flex>
                <v-flex xs4>
                  <v-btn  @click="$store.commit('incrementPalletAmountReturned')"> + </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-card>
          </v-flex>
          <v-flex xs6>
          <v-card>
              <div class="image-container">
                  <img class="rounded" alt="Halvpall" src="../assets/pallet-half.jpg">
                  <div class="description">Halvpall</div>
              </div>

            <div class="counter">
              <v-layout row wrap>
                <v-flex xs4>
                  <v-btn  @click="$store.commit('decrementPalletHalfAmountReturned')"> - </v-btn>
                </v-flex>
                <v-flex xs4>
                  <input class="palletDisplay" v-model="pallet_half_quantity_returned" readonly>
                </v-flex>
                <v-flex xs4>
                  <v-btn  @click="$store.commit('incrementPalletHalfAmountReturned')"> + </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-card>
          </v-flex>
          <v-flex xs6>
              <v-card>
                  <div class="image-container">
                      <img class="rounded" alt="Rullcontainer" src="../assets/rolling_pallet.jpg">
                      <div class="description">Rullcontainer</div>
                  </div>
                  <div class="counter">
                    <v-layout row wrap>
                    <v-flex xs4>
                      <v-btn  @click="$store.commit('decrementRollingPalletAmountReturned')"> - </v-btn>
                    </v-flex>
                    <v-flex xs4>
                      <input class="palletDisplay" v-model="rolling_pallet_quantity_returned" readonly>
                    </v-flex>
                    <v-flex xs4>
                      <v-btn  @click="$store.commit('incrementRollingPalletAmountReturned')"> + </v-btn>
                    </v-flex>
                    </v-layout>
                  </div>
              </v-card>
          </v-flex>
          <v-flex xs6>
              <v-card>
                  <div class="image-container">
                      <img class="rounded" alt="Engångspall" src="../assets/Engangspall.jpg">
                      <div class="description">Engångspall</div>
                  </div>

                  <div class="counter">
                      <v-layout row wrap>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('decrementDisposablePalletAmountReturned')"> - </v-btn>
                          </v-flex>
                          <v-flex xs4>
                              <input class="palletDisplay" v-model="disposable_pallet_quantity_returned" readonly>
                          </v-flex>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('incrementDisposablePalletAmountReturned')"> + </v-btn>
                          </v-flex>
                      </v-layout>
                  </div>
              </v-card>
          </v-flex>
          <v-flex xs6>
              <v-card>
                  <div class="image-container">
                      <img class="rounded" alt="Plastpall" src="../assets/plastpall.jpg">
                      <div class="description">Plastpall</div>
                  </div>

                <div class="counter">
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-btn  @click="$store.commit('decrementPlastpallAmountReturned')"> - </v-btn>
                    </v-flex>
                    <v-flex xs4>
                      <input class="palletDisplay" v-model="plastpall_quantity_returned" readonly>
                    </v-flex>
                    <v-flex xs4>
                      <v-btn  @click="$store.commit('incrementPlastpallAmountReturned')"> + </v-btn>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card>
          </v-flex>
          <v-flex xs6>
              <v-card>
                  <div class="image-container">
                      <img class="rounded" alt="Plastpall Halv" src="../assets/Plastpall-half.jpg">
                      <div class="description">Plastpall Halv</div>
                  </div>

                  <div class="counter">
                      <v-layout row wrap>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('decrementPlastpallHalfAmountReturned')"> - </v-btn>
                          </v-flex>
                          <v-flex xs4>
                              <input class="palletDisplay" v-model="plastpall_half_quantity_returned" readonly>
                          </v-flex>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('incrementPlastpallHalfAmountReturned')"> + </v-btn>
                          </v-flex>
                      </v-layout>
                  </div>
              </v-card>
          </v-flex>
          <v-flex xs6>
              <v-card>
                  <div class="image-container">
                      <img class="rounded" alt="Lökbin" src="../assets/lok-bin.jpg">
                      <div class="description">Lökbin</div>
                  </div>

                  <div class="counter">
                      <v-layout row wrap>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('decrementLokbinAmountReturned')"> - </v-btn>
                          </v-flex>
                          <v-flex xs4>
                              <input class="palletDisplay" v-model="lokbin_quantity_returned" readonly>
                          </v-flex>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('incrementLokbinAmountReturned')"> + </v-btn>
                          </v-flex>
                      </v-layout>
                  </div>
              </v-card>
          </v-flex>
          <v-flex xs6>
              <v-card>
                  <div class="image-container">
                      <img class="rounded" alt="Kyl" src="../assets/kyl.jpg">
                      <div class="description">Kyl</div>
                  </div>

                  <div class="counter">
                      <v-layout row wrap>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('decrementKylAmountReturned')"> - </v-btn>
                          </v-flex>
                          <v-flex xs4>
                              <input class="palletDisplay" v-model="kyl_quantity_returned" readonly>
                          </v-flex>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('incrementKylAmountReturned')"> + </v-btn>
                          </v-flex>
                      </v-layout>
                  </div>
              </v-card>
          </v-flex>
          <v-flex xs6>
              <v-card>
                  <div class="image-container">
                      <img class="rounded" alt="Jätten Bur" src="../assets/giant-cage.jpg">
                      <div class="description">Jätten Bur</div>
                  </div>

                  <div class="counter">
                      <v-layout row wrap>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('decrementGiantCageAmountReturned')"> - </v-btn>
                          </v-flex>
                          <v-flex xs4>
                              <input class="palletDisplay" v-model="giant_cage_quantity_returned" readonly>
                          </v-flex>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('incrementGiantCageAmountReturned')"> + </v-btn>
                          </v-flex>
                      </v-layout>
                  </div>
              </v-card>
          </v-flex>
          <v-flex xs6>
              <v-card>
                  <div class="image-container">
                      <img class="rounded" alt="Back" src="../assets/veg_crate.jpg">
                      <div class="description">Back</div>
                  </div>

                  <div class="counter">
                      <v-layout row wrap>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('decrementVegCrateAmountReturned')"> - </v-btn>
                          </v-flex>
                          <v-flex xs4>
                              <input class="palletDisplay" v-model="veg_crate_quantity_returned" readonly>
                          </v-flex>
                          <v-flex xs4>
                              <v-btn  @click="$store.commit('incrementVegCrateAmountReturned')"> + </v-btn>
                          </v-flex>
                      </v-layout>
                  </div>
              </v-card>
          </v-flex>
      </v-layout>
      <v-btn color="primary" block @click.native="goToReview">Fortsätt</v-btn>
    </v-container>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    data: function data() {
      return {
      }
    },
    methods:{
      goBack(){
        this.$router.push('Warehouse_Home');
      },
      goToReview(){
        this.$router.push('Review');
      }
    },
    computed: {
      rolling_pallet_quantity_returned: {
        get(){
          return this.$store.state.currentDelivery.expected_pallets.rolling_pallet;
        },
        set (){}
      },
      pallet_quantity_returned: {
        get(){
          return this.$store.state.currentDelivery.expected_pallets.pallet;
        },
        set (){}
      },
      pallet_half_quantity_returned: {
        get(){
          return this.$store.state.currentDelivery.expected_pallets.pallet_half;
        },
        set (){}
      },
      veg_crate_quantity_returned: {
        get(){
          return this.$store.state.currentDelivery.expected_pallets.veg_crate;
        },
        set (){}
      },
      plastpall_quantity_returned: {
        get(){
          return this.$store.state.currentDelivery.expected_pallets.plastpall;
        },
        set (){}
      },
      plastpall_half_quantity_returned: {
        get(){
          return this.$store.state.currentDelivery.expected_pallets.plastpall_half;
        },
        set (){}
      },
      lokbin_quantity_returned: {
        get(){
          return this.$store.state.currentDelivery.expected_pallets.lokbin;
        },
        set (){}
      },
      kyl_quantity_returned: {
        get(){
          return this.$store.state.currentDelivery.expected_pallets.kyl;
        },
        set (){}
      },
      giant_cage_quantity_returned: {
        get(){
          return this.$store.state.currentDelivery.expected_pallets.giant_cage;
        },
        set (){}
      },
      disposable_pallet_quantity_returned: {
        get(){
          return this.$store.state.currentDelivery.expected_pallets.disposable_pallet;
        },
        set (){}
      }
  },
  created: function() {
      if(this.$store.state.auth.token == null || this.$store.state.auth.token == ""){
          window.alert("Fel: Vänligen logga in");
          this.$router.push('/');
      }
  }
}
</script>

<style>
.palletDisplay{
  width: 30%;
  text-align: center;
}

.image-container{
    position: relative;
    top: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/Delivery_Details.vue